import React from "react";
import GameBoard from "./GameBoard";
import { Puzzle } from "../lib/Game";

const MiniGame: React.FC = () => {
  const puzzle: Puzzle = {
    rows: 5,
    cols: 5,
    cells: Array.from({ length: 5 }, (_, rowIndex) =>
      Array.from({ length: 5 }, (_, colIndex) => {
        const index = rowIndex * 5 + colIndex;
        const value = String.fromCharCode("A".charCodeAt(0) + index);
        return { id: index, value: value, isSelected: false };
      }),
    ),
  };

  return (
    <div>
      <GameBoard puzzle={puzzle} />
    </div>
  );
};

export default MiniGame;
